import { ComponentType, lazy } from "react";

/**
 * Lazy load helper. Mantido por compatibilidade — atualmente sem delay
 * artificial para evitar "flash" de loading entre navegações.
 */
export function lazyWithDelay<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
  _minDelay = 0
) {
  return lazy(factory);
}
